import { createFileRoute } from '@tanstack/react-router';
import { WarehousePage } from '@/pages/Warehouse';

export const Route = createFileRoute('/_admin/warehouse/')({
  component: WarehousePage,
});
